<template>
  <v-main class="tpadding">
    <v-container fluid>
      <v-card class="rounded-xl elevation-5">
        <v-toolbar dense dark color="pinkKonect" elevation="2">
          <v-toolbar-title>Reporte Regio Ruta</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn small text :loading="loadingReports" @click="exportarCSV">
            Descargar resultados
            <v-icon right>mdi-microsoft-excel</v-icon>
          </v-btn>
          <v-btn small text :loading="loadingExcel" :disabled="!isFiltroValido" @click="ui.modalReporte = true">
                Reporte Regio Ruta
                <v-icon right>mdi-file-chart-outline</v-icon>
              </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row no-gutters class="pb-4" style="justify-content: space-between">
            <v-col sm="10" style="align-self: center; display: flex; flex-direction: column">
              <v-row>
                <v-col cols="2" class="d-flex align-end">
                  <v-autocomplete
                    v-model="selectedClienteId"
                    :items="clientItem"
                    item-text="text"
                    item-value="value"
                    label="Cliente"
                    dense
                    clearable
                    prepend-inner-icon="mdi-account-multiple"
                    :loading="loadingClients"
                    hide-details
                    class="mt-1"
                  />
                </v-col>

                <v-col cols="3" class="d-flex align-end">
                  <v-autocomplete
                    v-model="selectedRamalIds"
                    :items="ramalItems"
                    item-text="text"
                    item-value="value"
                    label="Ramal (opcional)"
                    dense
                    clearable
                    multiple
                    chips
                    small-chips
                    prepend-inner-icon="mdi-sign-direction"
                    :disabled="!Number.isFinite(idclienteEff)"
                    :loading="loadingRamales"
                    hide-details
                    class="mt-1"
                    no-data-text="Selecciona un cliente"
                  />
                </v-col>

                <v-col cols="2" class="d-flex align-end">
                  <v-dialog
                    ref="dialogIni"
                    v-model="ui.modalIni"
                    :return-value.sync="filtros.fecha_inicio"
                    persistent
                    width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        :value="formatFechaDisplay(filtros.fecha_inicio)"
                        dense
                        label="Fecha inicio"
                        hide-details
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="ui.tmpIni"
                      scrollable
                      locale="es"
                      min="2025-07-01"
                      :max="fechaMaxReporte"
                    >
                      <v-spacer />
                      <v-btn text @click="ui.modalIni = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="acceptFechaInicio">Aceptar</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="2" class="d-flex align-end">
                  <v-dialog
                    ref="dialogFin"
                    v-model="ui.modalFin"
                    :return-value.sync="filtros.fecha_fin"
                    persistent
                    width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        :value="formatFechaDisplay(filtros.fecha_fin)"
                        dense
                        label="Fecha fin"
                        hide-details
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="ui.tmpFin"
                      :min="filtros.fecha_inicio || '2025-07-01'"
                      scrollable
                      locale="es"
                      :max="fechaMaxReporte"
                    >
                      <v-spacer />
                      <v-btn text @click="ui.modalFin = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="acceptFechaFin">Aceptar</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="3" class="pt-0 d-flex align-end">
                  <v-text-field
                    class="pt-0"
                    v-model="search"
                    label="Buscar"
                    single-line
                    hide-details
                    clearable
                    autocomplete="off"
                  />
                </v-col>


              </v-row>
            </v-col>

            <v-col sm="2" class="text-right" style="margin-top: 21px">
              <v-btn
                small
                outlined
                :loading="loading"
                :disabled="!isFiltroValido"
                color="blueKonect"
                class="ma-auto"
                elevation="0"
                @click="fetchResumen"
              >
                Consultar
                <v-icon right>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table
            :key="tableKey"
            :headers="headers"
            :items="itemsFiltered"
            :loading="loading"
            :items-per-page="10"
            item-key="_uid"
            loading-text="Cargando registros... Por favor espere"
            :footer-props="{
              itemsPerPageText: 'Elementos por página',
              itemsPerPageAllText: 'Todos',
              itemsPerPageOptions: [5, 10, 25, 50, -1]
            }"
          >
            <template #item.fecha_recorrido="{ item }">
              {{ item.fecha_recorrido_fmt }}
            </template>

            <template #item.actions="{ item }">
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    aria-label="Detalle en mapa"
                    @click="openMapa(item)"
                  >
                    <v-icon>mdi-map-marker</v-icon>
                  </v-btn>
                </template>
                <span>Detalle</span>
              </v-tooltip>
            </template>

            <template #no-data>No hay información disponible</template>
            <template #no-results>No se obtuvieron resultados</template>
          </v-data-table>

          <v-dialog v-model="dialogs.mapa" max-width="1200px" persistent>
            <v-card class="rounded-xl elevation-3">
              <v-toolbar dense dark color="pinkKonect" elevation="2">
                <v-toolbar-title>
                  Detalle — {{ selectedItem?.nombre_ramal || 'Ramal' }}
                  <small v-if="selectedItem" class="ml-2"> ({{ selectedItem?.fecha_recorrido_fmt || '-' }}) </small>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="onCloseMapa" aria-label="Cerrar">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text class="pa-0">
                <gmap-map
                  ref="gmapDetalle"
                  :center="map.center"
                  :zoom="map.zoom"
                  :options="map.options"
                  style="height: 65vh; width: 100%"
                >
                  <gmap-polyline
                    v-if="route.path.length"
                    :path="route.path"
                    :options="{ strokeColor: '#1976D2', strokeWeight: 4, strokeOpacity: 0.9 }"
                  />
                  <gmap-marker
                    v-if="route.start"
                    :position="route.start"
                    :label="{ text: 'I', color: '#fff' }"
                    :icon="{
                      path: google?.maps?.SymbolPath?.CIRCLE,
                      scale: 8,
                      fillColor: '#2E7D32',
                      fillOpacity: 1,
                      strokeColor: '#1B5E20',
                      strokeWeight: 1
                    }"
                  />
                  <gmap-marker
                    v-if="route.end"
                    :position="route.end"
                    :label="{ text: 'F', color: '#fff' }"
                    :icon="{
                      path: google?.maps?.SymbolPath?.CIRCLE,
                      scale: 8,
                      fillColor: '#C62828',
                      fillOpacity: 1,
                      strokeColor: '#8E0000',
                      strokeWeight: 1
                    }"
                  />
                </gmap-map>

                <v-sheet class="pa-4">
                  <div v-if="route.loading" class="d-flex align-center">
                    <v-progress-circular indeterminate class="mr-2" />
                    Cargando ruta…
                  </div>
                  <div v-else-if="route.error" class="error--text">
                    {{ route.error }}
                  </div>
                  <template v-else>
                    <div class="text-caption grey--text mb-1">No. Económico • Operador • Folio</div>
                    <div class="text--primary">
                      {{ selectedItem?.no_economico || '-' }} • {{ selectedItem?.operador || '-' }} • Folio
                      {{ selectedItem?.folio_boleta || '-' }}
                    </div>
                  </template>
                </v-sheet>
              </v-card-text>
            </v-card>
          </v-dialog>

          <errormsg
            v-if="error"
            class="mt-4"
            :text="codeError || 'Ocurrió un error al consultar el servicio'"
            @close="
              error = false
              codeError = ''
            "
          />
        </v-card-text>
      </v-card>

      <!-- Modal Reporte Regio Ruta -->
      <v-dialog v-model="ui.modalReporte" max-width="420" persistent>
        <v-card class="rounded-lg">
          <v-card-title class="text-h6">
            <v-icon left color="pinkKonect">mdi-file-chart-outline</v-icon>
            Reporte Regio Ruta
          </v-card-title>
          <v-card-text class="pb-2">
            <v-select
              v-model="tipoReporte"
              :items="tipoReporteItems"
              item-text="text"
              item-value="value"
              label="Tipo de reporte"
              dense
              outlined
              hide-details
              prepend-inner-icon="mdi-calendar-range"
              class="mb-4"
            />
            <div class="text-subtitle-2 mb-2">Formato de descarga</div>
            <v-btn block outlined color="green darken-2" class="mb-2" :loading="loadingExcel" @click="generarReporteExcel(); ui.modalReporte = false">
              <v-icon left>mdi-file-excel-outline</v-icon>
              Excel con formato
            </v-btn>
            <v-btn block outlined color="red darken-2" :loading="loadingExcel" @click="generarReportePDF(); ui.modalReporte = false">
              <v-icon left>mdi-file-pdf-box</v-icon>
              PDF
            </v-btn>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="ui.modalReporte = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </v-main>
</template>

<script>
import moment from 'moment-timezone'
import _ from 'lodash'
import services from '@/utils/services'
import downloadjs from 'downloadjs'
import XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { errormsg } from '@/components'
import { gmapApi } from 'vue2-google-maps'

export default {
  name: 'ReporteAscensosRepRegRt',
  components: { errormsg },

  data: () => ({
    loading: false,
    loadingReports: false,
    loadingExcel: false,
    loadingClients: false,
    loadingRamales: false,
    map: {
      center: { lat: 25.689665, lng: -100.310619 },
      zoom: 13,
      options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false
      }
    },
    error: false,
    codeError: '',

    filtros: {
      fecha_inicio: '2025-07-01',
      fecha_fin: moment().format('YYYY-MM-DD')
    },

    selectedClienteId: null,
    clientItem: [],
    itemsAux: [],

    selectedRamalIds: [],
    ramalItems: [],

    items: [],
    search: '',
    searchDebounced: '',
    headers: [
      { text: 'Fecha', value: 'fecha_recorrido', align: 'start' },
      { text: 'Ramal', value: 'nombre_ramal', align: 'start' },
      { text: 'No. Económico', value: 'no_economico', align: 'start' },
      { text: 'Operador', value: 'operador', align: 'start' },
      { text: 'Nómina', value: 'num_nomina', align: 'start' },
      { text: 'Turno', value: 'turno', align: 'end' },
      { text: 'Vuelta', value: 'vuelta', align: 'end' },
      { text: 'Pasajeros', value: 'total_pasajeros', align: 'end' },
      { text: 'Km', value: 'kilometros', align: 'end' },
      { text: 'Salida ida Plan', value: 'salida_ida_plan', align: 'start' },
      { text: 'Llegada ida Plan', value: 'llegada_ida_plan', align: 'start' },
      { text: 'Acciones', value: 'actions', align: 'center', sortable: false }
    ],

    dialogs: { mapa: false },
    selectedItem: null,
    markerPos: null,
    _gmap: { map: null, marker: null, lastCenter: null },
    ui: { modalIni: false, modalFin: false, modalReporte: false, tmpIni: null, tmpFin: null },

    route: {
      loading: false,
      path: [],
      start: null,
      end: null,
      stops: [],
      error: ''
    },

    tableKey: 0, // <-- NUEVO: para forzar re-render de la tabla si es necesario

    tipoReporte: 'diario',
    tipoReporteItems: [
      { text: 'Diario', value: 'diario' },
      { text: 'Semanal', value: 'semanal' },
      { text: 'Mensual', value: 'mensual' }
    ]
  }),

  created() {
    // Aumenta el delay del debounce para evitar ejecuciones excesivas
    this._applySearch = _.debounce((v) => {
      this.searchDebounced = v
    }, 400) // Aumentado a 400ms
    this.loadClients()
  },

  watch: {
    search(val) {
      // Limita el watch para evitar ejecuciones innecesarias
      if (this._applySearch) {
        this._applySearch(val)
      }
    },

    selectedClienteId() {
      this.selectedRamalIds = []
      this.ramalItems = []
      this.items = [] // <-- NUEVO: limpia los items al cambiar cliente
      this.search = '' // <-- NUEVO: limpia el búsqueda
      if (Number.isFinite(this.idclienteEff)) {
        this.loadRamales()
      }
    },

    'ui.modalIni'(open) {
      if (open) this.ui.tmpIni = this.filtros.fecha_inicio
    },

    'ui.modalFin'(open) {
      if (open) this.ui.tmpFin = this.filtros.fecha_fin
    }
  },

  computed: {
    google: gmapApi,
    fechaMaxReporte() {
      return moment().format('YYYY-MM-DD')
    },
    idclienteEff() {
      const ui = Number(this.selectedClienteId)
      return Number.isFinite(ui) && ui > 0 ? ui : NaN
    },
    isFiltroValido() {
      const { fecha_inicio, fecha_fin } = this.filtros
      const idclienteNum = this.idclienteEff
      const fechasOk = !!fecha_inicio && !!fecha_fin && String(fecha_inicio) <= String(fecha_fin)
      const clienteOk = Number.isFinite(idclienteNum) && idclienteNum > 0
      return fechasOk && clienteOk
    },
    itemsFiltered() {
      const addUid = (list) => list.map((item, i) => {
        if (!item._uid) {
          const folio = String(item?.folio_boleta || '').trim() || 'nf'
          const fecha = String(item?.fecha_recorrido || '').trim() || 'nd'
          const eco = String(item?.no_economico || '').trim() || 'ne'
          item._uid = `${folio}-${fecha}-${eco}-${i}`
        }
        return item
      })

      const q = String(this.searchDebounced || '')
        .toLowerCase()
        .trim()

      // Solo filtra si hay al menos 2 caracteres
      if (!q || q.length < 2) return addUid(this.items)

      // Usa try-catch para evitar errores que congelen la tabla
      try {
        return addUid(this.items.filter((item) => {
          // Verifica que item existe antes de acceder a sus propiedades
          if (!item) return false

          const searchableText = [
            item.folio_boleta,
            item.nombre_ramal,
            item.no_economico,
            item.operador,
            item.fecha_recorrido_fmt
          ]
            .filter((v) => v != null) // Filtra valores null/undefined
            .join(' ')
            .toLowerCase()

          return searchableText.includes(q)
        }))
      } catch (e) {
        console.error('Error en itemsFiltered:', e)
        return addUid(this.items) // Retorna items sin filtrar si hay error
      }
    }
  },

  beforeDestroy() {
    // Limpia el debounce
    if (this._applySearch) {
      this._applySearch.cancel()
    }

    // Limpia el state
    this.items = []
    this.search = ''
    this.searchDebounced = ''
  },

  methods: {
    formatFechaDisplay(iso) {
      if (!iso) return ''
      const m = moment(String(iso).slice(0, 10), 'YYYY-MM-DD', true)
      return m.isValid() ? m.format('DD/MM/YYYY') : String(iso)
    },

    acceptFechaInicio() {
      const picked = this.ui.tmpIni
      if (!picked) {
        this.ui.modalIni = false
        return
      }
      this.filtros.fecha_inicio = picked
      if (!this.filtros.fecha_fin || String(picked) > String(this.filtros.fecha_fin)) {
        this.filtros.fecha_fin = picked
        this.ui.tmpFin = picked
      }
      this.$refs.dialogIni.save(picked)
    },

    acceptFechaFin() {
      const picked = this.ui.tmpFin
      if (!picked) {
        this.ui.modalFin = false
        return
      }
      this.filtros.fecha_fin = picked
      if (!this.filtros.fecha_inicio || String(picked) < String(this.filtros.fecha_inicio)) {
        this.filtros.fecha_inicio = picked
        this.ui.tmpIni = picked
      }
      this.$refs.dialogFin.save(picked)
    },

    // ---- Helpers GeoJSON y URLs
    geojsonToPath(geo) {
      if (!geo || !geo.type || !geo.coordinates) return []
      const toLatLng = (pair) => {
        const [lng, lat] = pair || []
        return Number.isFinite(lat) && Number.isFinite(lng) ? { lat: Number(lat), lng: Number(lng) } : null
      }
      if (geo.type === 'LineString') {
        return (geo.coordinates || []).map(toLatLng).filter(Boolean)
      }
      if (geo.type === 'MultiLineString') {
        return (geo.coordinates || []).flatMap((line) => (line || []).map(toLatLng)).filter(Boolean)
      }
      return []
    },

    _buildMapRegRtUrls(base, id) {
      const b = String(base || 'mapRegRt/').trim()
      const be = b.endsWith('/') ? b : b + '/'
      const enc = encodeURIComponent(String(id))
      return [
        `${be}${enc}`, // GET /mapRegRt/:id
        `${b}?idrecorrido=${enc}` // GET /mapRegRt?idrecorrido=:id
      ]
    },

    normalizaFecha(str) {
      const m = moment(str, ['DD/MM/YYYY', 'YYYY-MM-DD', 'YYYY/MM/DD'], true)
      return m.isValid() ? m.format('DD/MM/YYYY') : str || '-'
    },

    async loadClients() {
      this.loadingClients = true
      try {
        const res = await services.ws('get', 'clients')
        this.itemsAux = Array.isArray(res?.data) ? res.data : []
        this.clientItem = this.itemsAux
          .map((c) => ({
            text: c.nombre_comercial,
            value: Number(c.idcliente),
            ext: c.idcliente_externo
          }))
          .filter((o) => Number.isFinite(o.value) && o.value > 0)
      } catch (error) {
        this.error = true
        this.codeError = _.get(error, 'response.data.message', 'No se pudieron cargar los clientes')
      } finally {
        this.loadingClients = false
      }
    },

    async loadRamales() {
      const idclienteNum = this.idclienteEff
      if (!Number.isFinite(idclienteNum)) return
      this.loadingRamales = true
      try {
        const baseUrl = _.get(services, 'routes.listRam', null)
        let resp
        if (baseUrl) {
          resp = await this.axios.get(`${baseUrl}${idclienteNum}`)
        } else {
          resp = await services.ws('get', `listRam/${idclienteNum}`)
        }

        const data = Array.isArray(resp?.data) ? resp.data : Array.isArray(resp?.data?.data) ? resp.data.data : []

        this.ramalItems = (data || [])
          .map((r) => ({
            text: r.nombre_ramal || r.nombre || `Ramal ${r.idramal ?? ''}`,
            value: Number(r.idramal ?? r.id_ramal ?? r.id) || null
          }))
          .filter((x) => Number.isFinite(x.value))
          .sort((a, b) => a.text.localeCompare(b.text, 'es'))
      } catch (e) {
        this.ramalItems = []
        this.error = true
        this.codeError = _.get(e, 'response.data.message', 'No se pudieron cargar los ramales')
      } finally {
        this.loadingRamales = false
      }
    },

    async fetchResumen() {
      try {
        this.loading = true
        this.error = false

        const idclienteNum = this.idclienteEff
        if (!Number.isFinite(idclienteNum) || idclienteNum <= 0) {
          this.error = true
          this.codeError = 'Debes seleccionar un cliente válido.'
          return
        }

        const payload = {
          idcliente: idclienteNum,
          fecha_inicio: this.filtros.fecha_inicio,
          fecha_fin: this.filtros.fecha_fin,
          idramal: Array.isArray(this.selectedRamalIds) && this.selectedRamalIds.length > 0 ? this.selectedRamalIds : []
        }

        const url = _.get(services, 'routes.repRegRt') || _.get(services, 'routes.resRd')
        const resp = url ? await this.axios.post(url, payload) : await services.ws('post', 'repRegRt', payload)

        const arr = Array.isArray(resp?.data)
          ? resp.data
          : Array.isArray(resp?.data?.data)
          ? resp.data.data
          : resp?.data
          ? [resp.data]
          : []

        // Mapea los datos de forma más segura
        this.items = (arr || []).map((r, idx) => {
          const row = {
            _index: idx, // <-- NUEVO: índice único interno
            folio_boleta: _.get(r, 'folio_boleta', ''),
            vuelta: Number(_.get(r, 'vuelta', 0)),
            total_pasajeros: Number(_.get(r, 'total_pasajeros', 0)),
            no_economico: _.get(r, 'no_economico', ''),
            num_nomina: _.get(r, 'num_nomina', ''),
            salida_ida_plan: _.get(r, 'salida_ida_plan', ''),
            llegada_ida_plan: _.get(r, 'llegada_ida_plan', ''),
            salida_ida_real: _.get(r, 'salida_ida_real', ''),
            llegada_ida_real: _.get(r, 'llegada_ida_real', ''),
            fecha_recorrido: _.get(r, 'fecha_recorrido', ''),
            frecuencia: _.get(r, 'frecuencia', ''),
            kilometros: Number(_.get(r, 'kilometros', 0)),
            turno: Number(_.get(r, 'turno', 0)),
            nombre_ramal: _.get(r, 'nombre_ramal', ''),
            operador: _.get(r, 'operador', ''),
            idrecorrido: _.get(r, 'idrecorrido', _.get(r, 'id_recorrido', null))
          }
          row.fecha_recorrido_fmt = this.normalizaFecha(row.fecha_recorrido)

          // Crea el texto de búsqueda de forma más segura
          const lower = (v) => String(v ?? '').toLowerCase()
          row._q = [
            row.folio_boleta,
            row.fecha_recorrido_fmt,
            row.nombre_ramal,
            row.no_economico,
            row.operador,
            row.num_nomina,
            row.turno,
            row.vuelta,
            row.total_pasajeros,
            row.kilometros,
            row.salida_ida_plan,
            row.llegada_ida_plan,
            row.salida_ida_real,
            row.llegada_ida_real,
            row.frecuencia
          ]
            .map(lower)
            .join('|')

          return row
        })

        // Fuerza un re-render de la tabla para evitar estados inconsistentes
        this.tableKey++

        // Limpia la búsqueda después de consultar
        this.$nextTick(() => {
          this.search = ''
          this.searchDebounced = ''
        })
      } catch (e) {
        this.error = true
        this.codeError = _.get(e, 'response.data.message', _.get(e, 'message', 'Error al consultar'))
      } finally {
        this.loading = false
      }
    },

    async fetchRuta(idrecorrido) {
      const id = String(idrecorrido || '').trim()
      if (!id) {
        this.route = { loading: false, path: [], start: null, end: null, stops: [], error: 'idrecorrido inválido' }
        return
      }

      this.route.loading = true
      this.route.error = ''
      this.route.path = []
      this.route.start = null
      this.route.end = null
      this.route.stops = []

      try {
        const base = _.get(services, 'routes.mapRegRt', 'georute/')
        const be = base.endsWith('/') ? base : base + '/'
        const url = `${be}${encodeURIComponent(id)}`
        const resp = await this.axios.get(url)

        const raw = resp?.data?.data ?? resp?.data ?? {}
        const root = Array.isArray(raw) ? raw[0] : raw
        const geo = _.get(root, 'georuta.georuta') || _.get(root, 'georuta') || root

        const coords = this.geojsonToPath(geo)
        if (!Array.isArray(coords) || coords.length < 2) {
          this.route.error = 'No se encontró la georuta para el recorrido.'
          return
        }

        this.route.path = coords
        this.route.start = coords[0]
        this.route.end = coords[coords.length - 1]

        // Fit bounds
        this.$nextTick(() => {
          const p = this.$refs.gmapDetalle?.$mapPromise
          if (p && this.google?.maps) {
            p.then((map) => {
              const bounds = new this.google.maps.LatLngBounds()
              this.route.path.forEach((c) => bounds.extend(c))
              map.fitBounds(bounds)
              const once = this.google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
                if (map.getZoom() > 18) map.setZoom(18)
              })
              setTimeout(() => this.google.maps.event.removeListener(once), 800)
            })
          }
        })
      } catch (e) {
        const backendMsg = _.get(e, 'response.data.message')
        this.route.error = backendMsg || 'No se pudo cargar la ruta del recorrido.'
      } finally {
        this.route.loading = false
      }
    },

    getUniqueKey(item, index) {
      // Clave más robusta que garantiza unicidad
      const folio = String(item?.folio_boleta || '').trim() || 'no-folio'
      const fecha = String(item?.fecha_recorrido || '').trim() || 'no-fecha'
      const eco = String(item?.no_economico || '').trim() || 'no-eco'
      return `${folio}-${fecha}-${eco}-${index}`
    },

    openMapa(item) {
      this.selectedItem = item || null

      const { lat, lng } = this.getCoordsFromItem(item)
      this.markerPos = Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : this.map.center

      this.dialogs.mapa = true

      this.$nextTick(() => {
        const p = this.$refs.gmapDetalle?.$mapPromise
        if (p) {
          setTimeout(() => {
            p.then((map) => {
              if (this.google?.maps) {
                this.google.maps.event.trigger(map, 'resize')
                map.setCenter(this.markerPos || this.map.center)
              }
            })
          }, 150)
        }
      })

      const idrec = String(_.get(item, 'idrecorrido', _.get(item, 'id_recorrido', ''))).trim()
      if (!idrec) {
        this.route.error = 'Este registro no trae idrecorrido.'
        return
      }
      this.fetchRuta(idrec)
    },

    onCloseMapa() {
      this.dialogs.mapa = false
      this.route = { loading: false, path: [], start: null, end: null, stops: [], error: '' }
    },

    getCoordsFromItem(item) {
      const lat = Number(item?.lat ?? item?.latitud ?? item?.latitude)
      const lng = Number(item?.lng ?? item?.longitud ?? item?.longitude)
      return { lat, lng }
    },

    toCsvRow(arr) {
      return arr
        .map((v) => {
          const s = String(v ?? '').replace(/"/g, '""')
          return /[",\n]/.test(s) ? `"${s}"` : s
        })
        .join(',')
    },

    async generarReporteExcel() {
      try {
        this.loadingExcel = true
        this.error = false

        const idclienteNum = this.idclienteEff
        if (!Number.isFinite(idclienteNum) || idclienteNum <= 0) {
          this.error = true
          this.codeError = 'Debes seleccionar un cliente válido.'
          return
        }

        const payload = {
          idcliente: idclienteNum,
          fecha_inicio: this.filtros.fecha_inicio,
          fecha_fin: this.filtros.fecha_fin,
          idramal: Array.isArray(this.selectedRamalIds) && this.selectedRamalIds.length > 0 ? this.selectedRamalIds : []
        }

        const resp = await services.ws('post', 'repRegRtReport', payload)
        if (!resp || !resp.ok) {
          this.error = true
          this.codeError = _.get(resp, 'message', 'Error al obtener datos del reporte')
          return
        }

        const data = resp.data
        const rutas = data?.rutas || []
        const totales = data?.totales || {}
        const filtros = data?.filtros || {}

        // Find client name
        const clienteObj = this.clientItem.find((c) => c.value === idclienteNum)
        const clienteNombre = clienteObj?.text || ''

        // Build the Excel worksheet
        await this._buildExcel(rutas, totales, filtros, clienteNombre)
      } catch (e) {
        this.error = true
        this.codeError = _.get(e, 'response.data.message', _.get(e, 'message', 'Error al generar reporte'))
      } finally {
        this.loadingExcel = false
      }
    },

    async generarReportePDF() {
      try {
        this.loadingExcel = true
        this.error = false

        const idclienteNum = this.idclienteEff
        if (!Number.isFinite(idclienteNum) || idclienteNum <= 0) {
          this.error = true
          this.codeError = 'Debes seleccionar un cliente válido.'
          return
        }

        const payload = {
          idcliente: idclienteNum,
          fecha_inicio: this.filtros.fecha_inicio,
          fecha_fin: this.filtros.fecha_fin,
          idramal: Array.isArray(this.selectedRamalIds) && this.selectedRamalIds.length > 0 ? this.selectedRamalIds : []
        }

        const resp = await services.ws('post', 'repRegRtReport', payload)
        if (!resp || !resp.ok) {
          this.error = true
          this.codeError = _.get(resp, 'message', 'Error al obtener datos del reporte')
          return
        }

        const data = resp.data
        const rutas = data?.rutas || []
        const totales = data?.totales || {}
        const filtros = data?.filtros || {}

        const clienteObj = this.clientItem.find((c) => c.value === idclienteNum)
        const clienteNombre = clienteObj?.text || ''

        await this._buildPDF(rutas, totales, filtros, clienteNombre)
      } catch (e) {
        console.error('Error generarReportePDF:', e)
        this.error = true
        this.codeError = _.get(e, 'response.data.message', _.get(e, 'message', 'Error al generar PDF'))
      } finally {
        this.loadingExcel = false
      }
    },

    _getReportTitle() {
      const labels = { diario: 'DIARIO', semanal: 'SEMANAL', mensual: 'MENSUAL' }
      return `REPORTE ${labels[this.tipoReporte] || 'DIARIO'} DE RECORRIDOS`
    },

    _groupDataByPeriod(rutas, tipo) {
      const periodKey = (fecha) => {
        const m = moment(fecha, ['YYYY-MM-DD', 'DD/MM/YYYY'])
        if (!m.isValid()) return 'sin-fecha'
        if (tipo === 'diario') return m.format('YYYY-MM-DD')
        if (tipo === 'semanal') return `${m.isoWeekYear()}-W${String(m.isoWeek()).padStart(2, '0')}`
        return m.format('YYYY-MM')
      }

      const periodLabel = (key) => {
        if (tipo === 'diario') return moment(key, 'YYYY-MM-DD').format('DD-MM-YYYY')
        if (tipo === 'semanal') {
          const weekNum = key.split('-W')[1]
          return `Sem ${parseInt(weekNum, 10)}`
        }
        const m = moment(key, 'YYYY-MM')
        return m.isValid() ? m.locale('es').format('MMMM YYYY').replace(/^\w/, c => c.toUpperCase()) : key
      }

      const periodsSet = new Set()
      rutas.forEach(ruta => {
        (ruta.ramales || []).forEach(ramal => {
          (ramal.recorridos || []).forEach(rec => {
            periodsSet.add(periodKey(rec.fecha))
          })
        })
      })

      const sortedKeys = [...periodsSet].sort()

      return sortedKeys.map(pk => {
        const filteredRutas = rutas.map(ruta => {
          const filteredRamales = (ruta.ramales || []).map(ramal => {
            const filteredRecs = (ramal.recorridos || []).filter(rec => periodKey(rec.fecha) === pk)
            // For weekly/monthly, aggregate recorridos by no_economico
            let finalRecs = filteredRecs
            if (tipo !== 'diario' && filteredRecs.length > 0) {
              const byEco = {}
              filteredRecs.forEach(rec => {
                const eco = rec.no_economico || ''
                if (!byEco[eco]) {
                  byEco[eco] = { ...rec, corridas: 0, km: 0, importe: 0 }
                }
                byEco[eco].corridas += rec.corridas || 1
                byEco[eco].km += rec.km || 0
                byEco[eco].importe += rec.importe || 0
              })
              finalRecs = Object.values(byEco)
            }
            return { ...ramal, recorridos: finalRecs }
          }).filter(r => r.recorridos.length > 0)

          let totalCorridas = 0
          let subtotalKm = 0
          let subtotalImporte = 0
          filteredRamales.forEach(r => {
            r.recorridos.forEach(rec => {
              totalCorridas += rec.corridas || 1
              subtotalKm += rec.km || 0
              subtotalImporte += rec.importe || 0
            })
          })

          return {
            ...ruta,
            ramales: filteredRamales,
            total_corridas: totalCorridas,
            subtotal_km: subtotalKm,
            subtotal_importe: subtotalImporte
          }
        }).filter(r => r.ramales.length > 0)

        let totalImporte = 0
        let totalKm = 0
        let totalCorridas = 0
        filteredRutas.forEach(r => {
          totalImporte += r.subtotal_importe || 0
          totalKm += r.subtotal_km || 0
          totalCorridas += r.total_corridas || 0
        })

        // Compute period date range
        let fechaInicio, fechaFin
        if (tipo === 'diario') {
          fechaInicio = moment(pk, 'YYYY-MM-DD')
          fechaFin = fechaInicio.clone()
        } else if (tipo === 'semanal') {
          const [year, week] = pk.split('-W').map(Number)
          fechaInicio = moment().isoWeekYear(year).isoWeek(week).startOf('isoWeek')
          fechaFin = fechaInicio.clone().endOf('isoWeek')
        } else {
          fechaInicio = moment(pk, 'YYYY-MM').startOf('month')
          fechaFin = fechaInicio.clone().endOf('month')
        }

        return {
          key: pk,
          label: periodLabel(pk),
          fechaInicio: fechaInicio.format('DD/MM/YYYY'),
          fechaFin: fechaFin.format('DD/MM/YYYY'),
          rutas: filteredRutas,
          totales: { importe: totalImporte, km: totalKm, corridas: totalCorridas }
        }
      })
    },

    async _buildExcel(rutas, totales, filtros, clienteNombre) {
      const ExcelJS = (await import(/* webpackChunkName: "exceljs" */ 'exceljs')).default || await import('exceljs')
      const workbook = new ExcelJS.Workbook()

      // --- Load logos from public folder (once per workbook) ---
      const [logoGobBuf, logoSecBuf] = await Promise.all([
        fetch('/img/logogobmty.png').then(r => r.arrayBuffer()),
        fetch('/img/logoregioruta.png').then(r => r.arrayBuffer()),
      ])
      const logoGobId = workbook.addImage({ buffer: logoGobBuf, extension: 'png' })
      const logoSecId = workbook.addImage({ buffer: logoSecBuf, extension: 'png' })

      // --- Group data by period ---
      const periods = this._groupDataByPeriod(rutas, this.tipoReporte)
      const totalSheets = periods.length
      const reportTitle = this._getReportTitle()

      periods.forEach((period, idx) => {
      const periodRutas = period.rutas
      const sheetNum = idx + 1
      const sheetName = period.label.substring(0, 31)
      const ws = workbook.addWorksheet(sheetName, {
        pageSetup: { paperSize: 9, orientation: 'landscape', fitToPage: true, fitToWidth: 1, fitToHeight: 0 }
      })

      // --- Column widths ---
      ws.columns = [
        { width: 5 },   // A - No.
        { width: 44 },  // B - CONCEPTO
        { width: 8 },   // C - UNIDAD
        { width: 14 },  // D - PRECIO UNITARIO
        { width: 12 },  // E - No. ECO
        { width: 14 },  // F - No. REPORTE
        { width: 14 },  // G - PERIODO INICIO
        { width: 14 },  // H - PERIODO FINAL
        { width: 11 },  // I - CORRIDAS
        { width: 12 },  // J - Km
        { width: 16 },  // K - IMPORTE
      ]

      // --- Styles ---
      const titleFont = { name: 'Arial', size: 12, bold: true }
      const subtitleFont = { name: 'Arial', size: 10, bold: true }
      const headerFont = { name: 'Arial', size: 8, bold: true, color: { argb: 'FFFFFFFF' } }
      const headerFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1F3864' } }
      const dataFont = { name: 'Arial', size: 8 }
      const subtotalFont = { name: 'Arial', size: 8, bold: true, color: { argb: 'FFFFFFFF' } }
      const subtotalFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2E5599' } }
      const centerAlign = { horizontal: 'center', vertical: 'middle' }
      const rightAlign = { horizontal: 'right', vertical: 'middle' }
      const leftAlign = { horizontal: 'left', vertical: 'middle' }
      const thin = { style: 'thin' }
      const border = { top: thin, left: thin, bottom: thin, right: thin }

      const fmtDate = (d) => moment(d, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY')
      const fmtMoney = (n) => Number((n || 0).toFixed(2))
      const fmtKm = (n) => Number((n || 0).toFixed(2))
      // ============ HEADER (rows 1-3) ============
      ws.addImage(logoGobId, { tl: { col: 0, row: 0 }, ext: { width: 150, height: 55 } })
      ws.addImage(logoSecId, { tl: { col: 9.3, row: 0 }, ext: { width: 175, height: 52 } })

      ws.mergeCells('C1:I1')
      const c1 = ws.getCell('C1')
      c1.value = 'SERVICIO DE TRANSPORTACIÓN REGIO RUTA'
      c1.font = titleFont
      c1.alignment = centerAlign

      ws.mergeCells('C2:I2')
      const c2 = ws.getCell('C2')
      c2.value = reportTitle
      c2.font = subtitleFont
      c2.alignment = centerAlign

      ws.getRow(1).height = 30
      ws.getRow(2).height = 25
      ws.getRow(3).height = 8 // spacer

      // ============ COLUMN HEADERS (rows 4-5) ============
      // Row 4 main headers — merge single-column headers across both rows
      const singleCols = [1, 2, 3, 4, 5, 6, 11] // A,B,C,D,E,F,K
      singleCols.forEach(c => {
        const letter = ws.getColumn(c).letter
        ws.mergeCells(`${letter}4:${letter}5`)
      })
      ws.mergeCells('G4:H4') // PERIODO
      ws.mergeCells('I4:J4') // RECORRIDO

      const headerRow4 = ['No.', 'CONCEPTO', 'UNIDAD', 'PRECIO\nUNITARIO', 'No. ECO', 'No. REPORTE', 'PERIODO', '', 'RECORRIDO', '', 'IMPORTE']
      headerRow4.forEach((txt, i) => {
        const cell = ws.getCell(4, i + 1)
        cell.value = txt
        cell.font = headerFont
        cell.fill = headerFill
        cell.alignment = { ...centerAlign, wrapText: true }
        cell.border = border
      })
      const subHeaders = [null, null, null, null, null, null, 'INICIO', 'FINAL', 'CORRIDAS', 'Km', null]
      subHeaders.forEach((txt, i) => {
        const cell = ws.getCell(5, i + 1)
        if (txt) cell.value = txt
        cell.font = headerFont
        cell.fill = headerFill
        cell.alignment = centerAlign
        cell.border = border
      })
      ws.getRow(4).height = 24
      ws.getRow(5).height = 18

      // ============ DATA ROWS ============
      let row = 6
      let acumuladoKm = 0
      let acumuladoImporte = 0
      let acumuladoCorridas = 0

      periodRutas.forEach((ruta, ri) => {
        let rutaRowNum = 1

        ;(ruta.ramales || []).forEach((ramal) => {
          const letraRamal = (ramal.nombre_ramal || '').charAt(0).toUpperCase() || String(ri + 1)

          ;(ramal.recorridos || []).forEach((rec) => {
            const m = moment(rec.fecha, ['YYYY-MM-DD', 'DD/MM/YYYY'])
            const ecoDigits = (rec.no_economico || '').match(/^\d+/)?.[0] || ''
            const noReporte = `${m.format('YYMM')}-${ecoDigits}`
            const isDaily = this.tipoReporte === 'diario'
            const r = ws.getRow(row)
            r.getCell(1).value = rutaRowNum
            r.getCell(2).value = `Servicio de transportación integral en la Ruta ${letraRamal}`
            r.getCell(3).value = 'Km'
            r.getCell(4).value = fmtMoney(ramal.costo_km)
            r.getCell(5).value = rec.no_economico || ''
            r.getCell(6).value = noReporte
            r.getCell(7).value = isDaily ? fmtDate(rec.fecha) : period.fechaInicio
            r.getCell(8).value = isDaily ? fmtDate(rec.fecha) : period.fechaFin
            r.getCell(9).value = rec.corridas || 1
            r.getCell(10).value = fmtKm(rec.km)
            r.getCell(11).value = fmtMoney(rec.importe)

            for (let c = 1; c <= 11; c++) {
              const cell = r.getCell(c)
              cell.font = dataFont
              cell.border = border
              if ([1, 3, 9].includes(c)) cell.alignment = centerAlign
              else if (c === 4) { cell.alignment = rightAlign; cell.numFmt = '$#,##0.00' }
              else if (c === 10) { cell.alignment = rightAlign; cell.numFmt = '#,##0.00' }
              else if (c === 11) { cell.alignment = rightAlign; cell.numFmt = '$#,##0.00' }
              else cell.alignment = leftAlign
            }
            rutaRowNum++
            row++
          })
        })

        // --- Subtotal row per ruta (blue highlight) ---
        // Derive ruta letter from first ramal's nombre_ramal
        const letraRuta = ((ruta.ramales || [])[0]?.nombre_ramal || '').charAt(0).toUpperCase() || String(ri + 1)
        const subR = ws.getRow(row)
        ws.mergeCells(`A${row}:H${row}`)
        subR.getCell(1).value = `TOTAL DE CORRIDAS RUTA ${letraRuta}, KM Y SUBTOTAL`
        subR.getCell(9).value = ruta.total_corridas || 0
        subR.getCell(10).value = fmtKm(ruta.subtotal_km)
        subR.getCell(11).value = fmtMoney(ruta.subtotal_importe)

        for (let c = 1; c <= 11; c++) {
          const cell = subR.getCell(c)
          cell.font = subtotalFont
          cell.fill = subtotalFill
          cell.border = border
          if (c === 11) { cell.alignment = rightAlign; cell.numFmt = '$#,##0.00' }
          else if (c >= 9) { cell.alignment = rightAlign; cell.numFmt = '#,##0.00' }
          else cell.alignment = leftAlign
        }
        subR.height = 18

        acumuladoKm += ruta.subtotal_km || 0
        acumuladoImporte += ruta.subtotal_importe || 0
        acumuladoCorridas += ruta.total_corridas || 0
        row++
      })

      // ============ EMPTY + SUBTOTAL ============
      row += 2
      ws.mergeCells(`A${row}:J${row}`)
      ws.getCell(`J${row}`).alignment = rightAlign
      ws.getCell(`K${row}`).value = fmtMoney(acumuladoImporte)
      ws.getCell(`K${row}`).font = { name: 'Arial', size: 10, bold: true }
      ws.getCell(`K${row}`).numFmt = '$#,##0.00'
      ws.getCell(`K${row}`).alignment = rightAlign
      ws.getCell(`K${row}`).border = border

      // SUB-TOTAL label
      ws.getCell(`I${row}`).value = 'SUB-TOTAL'
      ws.getCell(`I${row}`).font = { name: 'Arial', size: 10, bold: true }
      ws.getCell(`I${row}`).alignment = rightAlign
      row++

      // ACUMULADO VALOR DE EST. box
      row++
      ws.mergeCells(`I${row}:J${row + 1}`)
      const acumLabel = ws.getCell(`I${row}`)
      acumLabel.value = 'ACUMULADO\nVALOR DE EST.'
      acumLabel.font = { name: 'Arial', size: 9, bold: true }
      acumLabel.alignment = { ...centerAlign, wrapText: true }
      acumLabel.border = border

      ws.mergeCells(`K${row}:K${row + 1}`)
      const acumVal = ws.getCell(`K${row}`)
      acumVal.value = fmtMoney(acumuladoImporte)
      acumVal.font = { name: 'Arial', size: 10, bold: true }
      acumVal.numFmt = '$#,##0.00'
      acumVal.alignment = centerAlign
      acumVal.border = border

      // Ensure border renders on merged area bottom row
      ws.getCell(`I${row + 1}`).border = border
      ws.getCell(`K${row + 1}`).border = border
      row += 3

      // ============ SIGNATURE BLOCKS ============
      // Block 1: MONITOREO
      ws.mergeCells(`A${row}:C${row}`)
      const sig1Title = ws.getCell(`A${row}`)
      sig1Title.value = 'MONITOREO DEL SERVICIO\nKONECT LOGÍSTICA INTEGRADA'
      sig1Title.font = { name: 'Arial', size: 7, bold: true }
      sig1Title.alignment = { ...centerAlign, wrapText: true }
      sig1Title.border = { bottom: thin }

      // Block 2: PRESTADOR
      ws.mergeCells(`E${row}:G${row}`)
      const sig2Title = ws.getCell(`E${row}`)
      sig2Title.value = 'PRESTADOR DEL SERVICIO\nKONECT LOGÍSTICA INTEGRADA'
      sig2Title.font = { name: 'Arial', size: 7, bold: true }
      sig2Title.alignment = { ...centerAlign, wrapText: true }
      sig2Title.border = { bottom: thin }

      // Block 3: DIRECTOR GENERAL
      ws.mergeCells(`I${row}:K${row}`)
      const sig3Title = ws.getCell(`I${row}`)
      sig3Title.value = 'DIRECTOR GENERAL DE MOVILIDAD Y\nTRANSPORTE'
      sig3Title.font = { name: 'Arial', size: 7, bold: true }
      sig3Title.alignment = { ...centerAlign, wrapText: true }
      sig3Title.border = { bottom: thin }
      row++

      // Names under signatures
      ws.mergeCells(`A${row}:C${row}`)
      const sig1Name = ws.getCell(`A${row}`)
      sig1Name.value = 'EDGAR EMMANUEL MARTÍNEZ NUÑEZ'
      sig1Name.font = { name: 'Arial', size: 7 }
      sig1Name.alignment = centerAlign

      ws.mergeCells(`E${row}:G${row}`)
      const sig2Name = ws.getCell(`E${row}`)
      sig2Name.value = 'KARLA JEOVANA RAMIREZ ALEJANDRO'
      sig2Name.font = { name: 'Arial', size: 7 }
      sig2Name.alignment = centerAlign

      ws.mergeCells(`I${row}:K${row}`)
      const sig3Name = ws.getCell(`I${row}`)
      sig3Name.value = 'ING. JEAN CARLOS RUIZ GARCIA\nING. MONICA JANETH SÁNCHEZ'
      sig3Name.font = { name: 'Arial', size: 7 }
      sig3Name.alignment = { ...centerAlign, wrapText: true }
      row += 2

      // ============ CONTRATO FOOTER ============
      const blueTop = { top: { style: 'medium', color: { argb: 'FF1F3864' } } }
      for (let c = 1; c <= 11; c++) ws.getCell(row, c).border = blueTop

      ws.getCell(`A${row}`).value = 'CONTRATO:'
      ws.getCell(`A${row}`).font = { name: 'Arial', size: 8, bold: true }
      ws.getCell(`B${row}`).value = 'SDU-041-2025'
      ws.getCell(`B${row}`).font = { name: 'Arial', size: 8 }

      ws.getCell(`E${row}`).value = 'REPORTE No.'
      ws.getCell(`E${row}`).font = { name: 'Arial', size: 8, bold: true }
      const reportMonth = moment(filtros.fecha_fin, 'YYYY-MM-DD').format('MM/YYYY')
      ws.getCell(`F${row}`).value = reportMonth
      ws.getCell(`F${row}`).font = { name: 'Arial', size: 8 }

      // Hoja pagination
      ws.getCell(`J${row}`).value = `Hoja ${sheetNum} de ${totalSheets}`
      ws.getCell(`J${row}`).font = { name: 'Arial', size: 8, bold: true }
      ws.getCell(`J${row}`).alignment = { horizontal: 'right', vertical: 'middle' }

      }) // end periods.forEach

      // ============ DOWNLOAD ============
      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const fileName = `ReporteRegioRuta_${filtros.fecha_inicio}_a_${filtros.fecha_fin}.xlsx`
      saveAs(blob, fileName)
    },

    async _buildPDF(rutas, totales, filtros, clienteNombre) {
      const { jsPDF } = await import(/* webpackChunkName: "jspdf" */ 'jspdf')
      const autoTableModule = await import(/* webpackChunkName: "jspdf-autotable" */ 'jspdf-autotable')
      const autoTable = autoTableModule.default || autoTableModule.autoTable || autoTableModule

      const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'letter' })
      const pageW = doc.internal.pageSize.getWidth()
      const fmtDate = (d) => moment(d, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY')
      const fmtMoney = (n) => `$${(n || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
      const fmtNum = (n) => (n || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')

      // --- Logos ---
      const toBase64 = (url) => fetch(url).then(r => r.blob()).then(b => new Promise((ok) => {
        const reader = new FileReader()
        reader.onloadend = () => ok(reader.result)
        reader.readAsDataURL(b)
      }))

      const [logoGobB64, logoSecB64] = await Promise.all([
        toBase64('/img/logogobmty.png'),
        toBase64('/img/logoregioruta.png'),
      ])

      // --- Group data by period ---
      const periods = this._groupDataByPeriod(rutas, this.tipoReporte)
      const totalPages = periods.length
      const reportTitle = this._getReportTitle()

      periods.forEach((period, idx) => {
      const periodRutas = period.rutas
      const periodTotales = period.totales
      const pageNum = idx + 1
      if (idx > 0) doc.addPage()

      doc.addImage(logoGobB64, 'PNG', 10, 8, 38, 14)
      doc.addImage(logoSecB64, 'PNG', pageW - 52, 8, 42, 13)

      // --- Title ---
      doc.setFont('helvetica', 'bold')
      doc.setFontSize(12)
      doc.text('SERVICIO DE TRANSPORTACIÓN REGIO RUTA', pageW / 2, 14, { align: 'center' })
      doc.setFontSize(10)
      doc.text(reportTitle, pageW / 2, 20, { align: 'center' })

      // --- Build table data ---
      const bodyRows = []
      const subtotalRowIndices = []

      periodRutas.forEach((ruta, ri) => {
        let rutaRowNum = 1
        ;(ruta.ramales || []).forEach((ramal) => {
          const letraRamal = (ramal.nombre_ramal || '').charAt(0).toUpperCase() || String(ri + 1)
          ;(ramal.recorridos || []).forEach((rec) => {
            const m = moment(rec.fecha, ['YYYY-MM-DD', 'DD/MM/YYYY'])
            const ecoDigits = (rec.no_economico || '').match(/^\d+/)?.[0] || ''
            const noReporte = `${m.format('YYMM')}-${ecoDigits}`
            const isDaily = this.tipoReporte === 'diario'
            bodyRows.push([
              rutaRowNum,
              `Servicio de transportación integral en la Ruta ${letraRamal}`,
              'Km',
              fmtMoney(ramal.costo_km),
              rec.no_economico || '',
              noReporte,
              isDaily ? fmtDate(rec.fecha) : period.fechaInicio,
              isDaily ? fmtDate(rec.fecha) : period.fechaFin,
              rec.corridas || 1,
              fmtNum(rec.km),
              fmtMoney(rec.importe),
            ])
            rutaRowNum++
          })
        })
        // Subtotal row
        const letraRuta = ((ruta.ramales || [])[0]?.nombre_ramal || '').charAt(0).toUpperCase() || String(ri + 1)
        subtotalRowIndices.push(bodyRows.length)
        bodyRows.push([
          { content: `TOTAL DE CORRIDAS RUTA ${letraRuta}, KM Y SUBTOTAL`, colSpan: 8 },
          ruta.total_corridas || 0,
          fmtNum(ruta.subtotal_km),
          fmtMoney(ruta.subtotal_importe),
        ])
      })

      // --- Auto Table ---
      const darkBlue = [31, 56, 100]
      const medBlue = [46, 85, 153]

      autoTable(doc, {
        startY: 26,
        margin: { left: 10, right: 10 },
        theme: 'grid',
        styles: { font: 'helvetica', fontSize: 6, cellPadding: 1.2, lineColor: [0, 0, 0], lineWidth: 0.1 },
        headStyles: { fillColor: darkBlue, textColor: 255, fontStyle: 'bold', halign: 'center', valign: 'middle', fontSize: 6 },
        head: [
          [
            { content: 'No.', rowSpan: 2 },
            { content: 'CONCEPTO', rowSpan: 2 },
            { content: 'UNIDAD', rowSpan: 2 },
            { content: 'PRECIO\nUNITARIO', rowSpan: 2 },
            { content: 'No. ECO', rowSpan: 2 },
            { content: 'No. REPORTE', rowSpan: 2 },
            { content: 'PERIODO', colSpan: 2 },
            { content: 'RECORRIDO', colSpan: 2 },
            { content: 'IMPORTE', rowSpan: 2 },
          ],
          ['', '', '', '', '', '', 'INICIO', 'FINAL', 'CORRIDAS', 'Km', ''],
        ],
        body: bodyRows,
        columnStyles: {
          0: { halign: 'center', cellWidth: 8 },
          1: { halign: 'left', cellWidth: 62 },
          2: { halign: 'center', cellWidth: 12 },
          3: { halign: 'right', cellWidth: 18 },
          4: { halign: 'center', cellWidth: 14 },
          5: { halign: 'center', cellWidth: 18 },
          6: { halign: 'center', cellWidth: 20 },
          7: { halign: 'center', cellWidth: 20 },
          8: { halign: 'center', cellWidth: 14 },
          9: { halign: 'right', cellWidth: 16 },
          10: { halign: 'right', cellWidth: 22 },
        },
        didParseCell: function (data) {
          if (data.section === 'body' && subtotalRowIndices.includes(data.row.index)) {
            data.cell.styles.fillColor = medBlue
            data.cell.styles.textColor = 255
            data.cell.styles.fontStyle = 'bold'
          }
        },
      })

      // --- Footer area ---
      let y = (doc.lastAutoTable?.finalY || doc.previousAutoTable?.finalY || 180) + 6
      const pageH = doc.internal.pageSize.getHeight()

      // Check if we need a new page for footer
      if (y + 50 > pageH) {
        doc.addPage()
        y = 15
      }

      // SUB-TOTAL
      doc.setFont('helvetica', 'bold')
      doc.setFontSize(9)
      doc.text('SUB-TOTAL', pageW - 55, y, { align: 'right' })
      doc.text(fmtMoney(periodTotales.importe || 0), pageW - 12, y, { align: 'right' })
      y += 5

      // ACUMULADO
      doc.setDrawColor(0)
      doc.rect(pageW - 65, y, 55, 10)
      doc.setFontSize(7)
      doc.text('ACUMULADO\nVALOR DE EST.', pageW - 55, y + 4, { align: 'center', maxWidth: 25 })
      doc.setFontSize(9)
      doc.text(fmtMoney(periodTotales.importe || 0), pageW - 12, y + 6, { align: 'right' })
      y += 18

      // --- Signature blocks ---
      doc.setFontSize(6)
      doc.setFont('helvetica', 'bold')
      const sigY = y
      const sig1X = 40
      const sig2X = pageW / 2
      const sig3X = pageW - 40

      doc.setDrawColor(0)
      doc.line(sig1X - 28, sigY, sig1X + 28, sigY)
      doc.text('MONITOREO DEL SERVICIO\nKONECT LOGÍSTICA INTEGRADA', sig1X, sigY + 3, { align: 'center' })
      doc.setFont('helvetica', 'normal')
      doc.text('EDGAR EMMANUEL MARTÍNEZ NUÑEZ', sig1X, sigY + 8, { align: 'center' })

      doc.setFont('helvetica', 'bold')
      doc.line(sig2X - 28, sigY, sig2X + 28, sigY)
      doc.text('PRESTADOR DEL SERVICIO\nKONECT LOGÍSTICA INTEGRADA', sig2X, sigY + 3, { align: 'center' })
      doc.setFont('helvetica', 'normal')
      doc.text('KARLA JEOVANA RAMIREZ ALEJANDRO', sig2X, sigY + 8, { align: 'center' })

      doc.setFont('helvetica', 'bold')
      doc.line(sig3X - 28, sigY, sig3X + 28, sigY)
      doc.text('DIRECTOR GENERAL DE MOVILIDAD Y\nTRANSPORTE', sig3X, sigY + 3, { align: 'center' })
      doc.setFont('helvetica', 'normal')
      doc.text('ING. JEAN CARLOS RUIZ GARCIA\nING. MONICA JANETH SÁNCHEZ', sig3X, sigY + 8, { align: 'center' })
      y = sigY + 16

      // --- CONTRATO Footer ---
      doc.setDrawColor(31, 56, 100)
      doc.setLineWidth(0.5)
      doc.line(10, y, pageW - 10, y)
      y += 4
      doc.setFontSize(7)
      doc.setFont('helvetica', 'bold')
      doc.text('CONTRATO:', 12, y)
      doc.setFont('helvetica', 'normal')
      doc.text('SDU-041-2025', 32, y)

      doc.setFont('helvetica', 'bold')
      doc.text('REPORTE No.', pageW / 2 - 10, y)
      doc.setFont('helvetica', 'normal')
      const reportMonth = moment(filtros.fecha_fin, 'YYYY-MM-DD').format('MM/YYYY')
      doc.text(reportMonth, pageW / 2 + 15, y)

      // Hoja pagination
      doc.setFont('helvetica', 'bold')
      doc.text(`Hoja ${pageNum} de ${totalPages}`, pageW - 12, y, { align: 'right' })

      }) // end periods.forEach

      // --- Save ---
      const fileName = `ReporteRegioRuta_${filtros.fecha_inicio}_a_${filtros.fecha_fin}.pdf`
      doc.save(fileName)
    },

    exportarCSV() {
      try {
        this.loadingReports = true
        const dataset = this.itemsFiltered
        const headers = this.headers.filter((h) => h.value !== 'actions').map((h) => h.text)
        const keys = this.headers.filter((h) => h.value !== 'actions').map((h) => h.value)

        const rows = (dataset || []).map((row) =>
          keys.map((k) => (k === 'fecha_recorrido' ? row.fecha_recorrido_fmt : row[k]))
        )

        const csv = [this.toCsvRow(headers), ...rows.map(this.toCsvRow)].join('\n')
        const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' })
        const nombre = `repRegRt_${this.filtros.fecha_inicio}_a_${this.filtros.fecha_fin}.csv`
        downloadjs(blob, nombre, 'text/csv;charset=utf-8')
      } catch (e) {
        this.error = true
        this.codeError = e.message || 'Error al exportar CSV'
      } finally {
        this.loadingReports = false
      }
    }
  }
}
</script>

<style scoped>
.v-application--is-ltr .v-btn-toggle > .v-btn.v-btn:not(:first-child) {
  border-left-width: 1;
}
#mapa-detalle {
  background: #f5f5f5;
}
</style>
